import { Session } from "../../Authentication";
import { Venue } from "../../schema";
import {
  getVenueHasSimpleOrdering,
  getVenueHasTablePayOrdering,
} from "../../venueSelectors";
import { getCustomerTabBalance } from "../BillSplit/selectors";
import { CustomerTab } from "../CustomerTab/schema";

export const getIsWishlist = (session: Session, venue: Venue): boolean => {
  return !isRunningTab(session) && !getVenueHasSimpleOrdering(venue);
};
export const isRunningTab = (session: Session): boolean =>
  !!session.customerTab;
export const hasPendingCart = (session: Session): boolean =>
  session.cart.items.length > 0;

export const getTabTotal = (customerTab?: CustomerTab | null): number => {
  if (!customerTab) return 0;
  return getCustomerTabBalance(customerTab);
};

export const getCanAddToCart = (session: Session, venue: Venue): boolean => {
  return !(isRunningTab(session) && !getVenueHasTablePayOrdering(venue));
};
